import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { mergeAppResources } from '../utils/profileMerge';

const AppResourcesContext = createContext(null);

const isObject = (value) => value != null && typeof value === 'object' && !Array.isArray(value);

export const useAppResources = () => {
  const context = useContext(AppResourcesContext);
  if (!context) {
    return {
      appResources: null,
      metadata: null,
      gettoncini: null,
      learnedTerms: null,
      stelline: null,
      streak: null,
      replaceAppResources: () => {},
      updateAppResourcesLocally: () => {},
    };
  }
  return context;
};

export const AppResourcesProvider = ({ children }) => {
  const [appResources, setAppResources] = useState(null);

  const replaceAppResources = useCallback((resources) => {
    setAppResources(isObject(resources) ? resources : null);
  }, []);

  const updateAppResourcesLocally = useCallback((updatesOrUpdater) => {
    setAppResources((prev) => {
      const currentResources = isObject(prev) ? prev : {};
      const updates = typeof updatesOrUpdater === 'function'
        ? updatesOrUpdater(currentResources)
        : updatesOrUpdater;
      return mergeAppResources(currentResources, updates);
    });
  }, []);

  const value = useMemo(() => ({
    appResources,
    metadata: isObject(appResources?.metadata) ? appResources.metadata : null,
    gettoncini: isObject(appResources?.gettoncini) ? appResources.gettoncini : null,
    learnedTerms: isObject(appResources?.learned_terms) ? appResources.learned_terms : null,
    stelline: isObject(appResources?.stelline) ? appResources.stelline : null,
    streak: isObject(appResources?.streak) ? appResources.streak : null,
    replaceAppResources,
    updateAppResourcesLocally,
  }), [appResources, replaceAppResources, updateAppResourcesLocally]);

  return (
    <AppResourcesContext.Provider value={value}>
      {children}
    </AppResourcesContext.Provider>
  );
};
